function alertParameterHierarchyController($scope, alertsFrameworkService, hierarchyService) {
    const $ctrl = this;

    $ctrl.isHierarchyLoading = false;

    $ctrl.rootNode = [];
  
    $ctrl.$onInit = function() {
        loadHierarchy();

        $ctrl.hierarchyNodeKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);

        /* I had to use a watch since FancyDropDown's onChange fires before the hierarchyNodeIds are updated */
        $scope.$watch(
            () => $ctrl.hierarchyNodeKeys,
            (newVal, oldVal) => {
                if (newVal != oldVal) {
                    const csvValue = alertsFrameworkService.getCsvFromKeyArray(newVal);
		
                    $ctrl.onUpdate({csvValue: csvValue});
                }
            }
        );
    }

    /* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual = 
				newKeys.length === $ctrl.hierarchyNodeKeys.length 
				&& newKeys.every((value, index) => value === $ctrl.hierarchyNodeKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.hierarchyNodeKeys = newKeys;
			}        
		}		
    }
   
    function loadHierarchy() {
        $ctrl.isHierarchyLoading = true;

        hierarchyService
            .getHierarchyV2($ctrl.subscriberKey, $ctrl.hierarchyTypeKey)
            .then((rootNode) => {

                prepareNodeForFancyDropDown(rootNode);

                $ctrl.rootNode = [rootNode];
                $ctrl.isHierarchyLoading = false;
            });
    }
        

    function prepareNodeForFancyDropDown(node) {
        node.label = node.hierarchyNodeNameOverride || node.hierarchyNodeName;
        node.name = node.label;
        node.id = node.hierarchyNodeKey;

        if (node.children && node.children.length > 0) {
            node.children.forEach(childNode => {
                prepareNodeForFancyDropDown(childNode);
            });
        }
    }
}

angular
    .module("angus.components")
    .component("alertParameterHierarchy", {
        controller: alertParameterHierarchyController,
        bindings: {
            subscriberKey: "<",
            label: "<",
            model: "<",
            isReadOnly: "<",
            onUpdate: "&",
            hierarchyTypeKey: "<"
        },
        template: `
            <label class="control-label" ng-if="!hideLabel">{{$ctrl.label || 'Divisions' }}</label>
            <div ng-if="$ctrl.rootNode.length > 0">
                <fancy-drop-down 
                    allow-multi-select="true" 
                    id-field="'hierarchyNodeKey'" 
                    collection="$ctrl.rootNode" 
                    append-to="'.alert-details'" 
                    ng-model="$ctrl.hierarchyNodeKeys" 
                    ng-disabled="ngDisabled || $ctrl.isReadOnly" 
                    control-class="col-md-7" 
                />
            </div>
        `
    });
 